import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['approver', 'submit'];

  connect() {
    this.toggle();
  }

  toggle() {
    if (!this.hasApproverTarget || !this.hasSubmitTarget) return;

    this.submitTarget.disabled = !this.approverTarget.value;
  }
}
